import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';
import LoadingSpinner from '@/components/LoadingSpinner';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles = [] 
}) => {
  const { isLoading, isAuthenticated, user } = useAuth();

  if (isLoading) {
    return <LoadingSpinner isLoading={true} title="Verificando autenticação..." />;
  }
  if (!isAuthenticated) {
    console.error('Usuário não autenticado, redirecionando para login.', user);
    return <Navigate to="/authentication/side-login" replace />;
  }

  if (requiredRoles.length > 0 && user && !requiredRoles.includes(user.role)) {
    // Se o usuário não tem o role necessário, redireciona para a página apropriada
    if (user.role === 'admin') {
      return <Navigate to="/" replace />;
    } else if (user.role === 'coordenadora' || user.role === 'revendedora') {
      return <Navigate to="/home" replace />;
    } else if (user.role === 'cliente') {
      return <Navigate to="/home-cliente" replace />;
    } else {
      return <Navigate to="/nova-venda" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
